export default {
  active: 'Active',
  default: 'Default',
  settled: 'Settled',
};
